<template>
  <div>
    <investor-bank-accounts
      v-if="isMounted"
      :is-moral="isMoral"
      :person-type="investorType"
      :user-id="currentInvestorUserId"
      :has-backoffice-access="hasBackofficeAccess"
      :user-data="base"
    />

  </div>
</template>

<script>
import InvestorBankAccounts from "@/views/admin/investor/profile/InvestorBankAccounts";
import investorInfoHelper from "@/helpers/investorInfoHelper";
export default {
  name: "InvestorBank",
  components: {
    InvestorBankAccounts,
  },
  mixins: [investorInfoHelper],
  data(){
    return {
      isMounted: false,
      errorMssg: '',
      successMssg: '',
      investorType: null,
      isMoral: false,
      currentInvestorUserId: null,
      hasBackofficeAccess: null,

      // objeto principal
      base: {},
      InvestorId: null,
    }
  },
  async beforeMount() {
    this.showLoading(true);
    this.isMounted = false;
    this.InvestorId = this.$route.params.id;
    const requiredObjects = ['user.personal', 'user.business.personal'];
    this.base = await this.getInvestorData(this.InvestorId, requiredObjects);
    this.currentInvestorUserId = this.base.user.id;
    this.investorType = this.getInvestorType(this.base);
    this.isMoral = this.userIsMoral(this.investorType);
    this.hasBackofficeAccess = this.$acl.check('isBackoffice');
    this.isMounted = true;
    this.showLoading(false);
  },
  computed: {
  },
}
</script>
